module.exports = __webpack_public_path__ + "static/miniature2-54a62368fd8f8c6102739c693c592b06.jpg";